import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { DropArea } from './DropArea.js';
import { ExistingFileStatus } from './ExistingFileStatus.js';
import { FileStatus } from './FileStatus.js';
import { UploadInput } from './UploadInput.js';
export const FileUpload = ({ files, existingFiles, onFileAdd, onFileRemove, onExistingFileRemove, title, subtitle, uploadButtonText, disabled, minHeight, multiple, validateFile, accept, dataTestId, }) => {
    const handleFileAdd = useCallbackRef((file) => {
        if (validateFile && !validateFile(file, files)) {
            return;
        }
        onFileAdd(file);
    });
    return (_jsxs(DropArea, { title: title, subtitle: subtitle, input: _jsx(UploadInput, { onFileAdd: handleFileAdd, disabled: disabled, uploadButtonText: uploadButtonText, multiple: multiple, accept: accept }), disabled: disabled, onFileAdd: handleFileAdd, minHeight: minHeight, multiple: multiple, accept: accept, dataTestId: dataTestId, children: [existingFiles?.map((file) => (_jsx(ExistingFileStatus, { file: file, onRemove: onExistingFileRemove }, file.id.toString()))), files.map((file) => (_jsx(FileStatus, { file: file, onRemove: onFileRemove, progress$: file.progress, error: file.error }, file.id)))] }));
};
